import React, { useEffect, useReducer, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  createemployee,
  employeeData,
  employeeDataMange,
  updateUser,
} from "./employeeData";
import MaterialTypography from "../../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import ImageSelector from "../../components/ImageSelector";
import MaterialButton from "../../../components/MaterialButton";
import { useMutation } from "@apollo/client";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/LodingContext";
import Switch from "@mui/material/Switch";
import PDFSelector from "../../components/PDFSelector";
import MaterialSelect from "../../../components/MasterSelect";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import { allRoles } from "../role/roleCreate/roleData";
import FullscreenIcon from '@mui/icons-material/Fullscreen';

const EmployeeForm = () => {
  const [employeeState, dispatch] = useReducer(employeeDataMange, employeeData);
  const [roleDataOption, setRoleDataOption] = useState([]);
  const [departmentDataOption, setDepartmentDataOption] = useState([]);
  const [inputDisble, setInputDisble] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [departmentLoading, setDepartmentLoading] = useState(false);
  const [createUser, { loading, error }] = useMutation(createemployee);
  const [UpdateEmployee] = useMutation(updateUser);
  const { setCirleLoading } = useLoading();
  const [dialogOpen,setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [imageId,setImageId]= useState(null);

  
  

  const formType = location?.state?.type;
  const formValue = location?.state?.data;

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      employeeState.emailStatus === "success" &&
      employeeState.employeeCodeStatus === "success" &&
      employeeState.employeeNameStatus === "success" &&
      employeeState.contactNumberStatus === "success" &&
      employeeState.addressStatus === "success" &&
      employeeState.roleStatus === "success" &&
      employeeState.departmentStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  useEffect(() => {
    fetchRoledata();
    fetchDepartmentdata();
  }, []);

  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.employeeCode,
        name: "employeeCode",
      });
      dispatch({
        value: formValue?.employeeName,
        name: "employeeName",
      });
      dispatch({
        value: formValue?.contactNumber,
        name: "contactNumber",
      });
      dispatch({
        value: formValue?.address,
        name: "address",
      });
      dispatch({
        value: { value: formValue?.role?.id, label: formValue?.role?.role },
        name: "role",
      });
      dispatch({
        value: formValue?.profilePicture,
        name: "profilePicture",
      });
      dispatch({
        value: formValue?.department,
        name: "department",
      });
      dispatch({
        value: formValue?.email,
        name: "email",
      });
      dispatch({
        value: formValue?.webUse,
        name: "webUse",
      });
      dispatch({
        value: formValue?.mobileUse,
        name: "mobileUse",
      });
      dispatch({
        value: formValue?.isActive,
        name: "isActive",
      });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const handleImageSelect = (file) => {
    dispatch({ value: file, name: "profilePicture" });
  };

  const fetchRoledata = () => {
    setRoleLoading(true);
    request(BASEURL, allRoles)
      .then((res) => {
        setRoleDataOption(res?.allRoles[0]?.data);
      })
      .finally(() => {
        setRoleLoading(false);
      });
  };

  const fetchDepartmentdata = () => {
    setDepartmentLoading(true);
    request(BASEURL, allRoles)
      .then((res) => {
        setDepartmentDataOption(res?.allRoles[0]?.data);
      })
      .finally(() => {
        setDepartmentLoading(false);
      });
  };

  const handleAddEmployee = async () => {
    setCirleLoading(true);

    try {
      const response = await createUser({
        variables: {
          input: {
            email: employeeState?.email,
            employeeCode: employeeState?.employeeCode,
            employeeName: employeeState?.employeeName,
            contactNumber: employeeState?.contactNumber,
            address: employeeState?.address,
            role: employeeState?.role?.value,
            department: employeeState?.department.value,
            profilePicture: employeeState?.profilePicture,

            mobileUse: employeeState?.mobileUse,
            webUse: employeeState?.webUse,
          },
        },
        context: { hasUpload: true },
      });

      const status = response?.data?.createUser?.success;
      const message = response?.data?.createUser?.message;
      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/employee");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network Error",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdateEmployee = async () => {
    setCirleLoading(true);

    try {
      const response = await UpdateEmployee({
        variables: {
          input: {
            id: formValue?.id,

            employeeCode: employeeState?.employeeCode,
            employeeName: employeeState?.employeeName,
            contactNumber: employeeState?.contactNumber,
            address: employeeState?.address,
            role: employeeState?.role?.value,
            department: employeeState?.department,
            profilePicture: employeeState?.profilePicture?.name
              ? employeeState?.profilePicture
              : null,

            mobileUse: employeeState?.mobileUse,
            webUse: employeeState?.webUse,
            isActive: employeeState?.isActive,
          },
        },
        context: { hasUpload: true },
      });
      const status = response?.data?.updateUser?.success;
      const message = response?.data?.updateUser?.message;
      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/employee");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network Error",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handlePdfSelect = (file) => {
    dispatch({ value: file, name: "residencyPermit" });
  };

  const handleDownload = async() =>{
  
    const imageUrl = formValue?.profilePicture;
    if(!imageUrl) return;
    
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download ="employee_image.jpg";
    a.click();
     URL.revokeObjectURL(url);
  }

  return (
    <DashboardLayout>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
      >
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden", // prevent scrollbars
            p: 0,
          }}
        >
          {ImageSelector ? (
            <img
              src={formValue?.profilePicture}
              alt="Employee"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "8px",
                objectFit: "contain",
                display: "block",
              }}
            />
          ) : (
            <MaterialTypography>No image available</MaterialTypography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
          {formType == "view" ? (
            <Button onClick={handleDownload}>Download</Button>
          ) : (
            ""
          )}
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Employee Details"
                    : formType == "edit"
                      ? "Edit Employee Details"
                      : "View Employee Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={employeeState?.employeeCode}
                  name="employeeCode"
                  placeholder="Enter Employee Code"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value?.toUpperCase(),
                      name: "employeeCode",
                    })
                  }
                  error={
                    employeeState.employeeCodeStatus === "error" ? true : false
                  }
                  success={
                    employeeState.employeeCodeStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={employeeState?.employeeName}
                  name="employeeName"
                  placeholder="Enter  Employee Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "employeeName" })
                  }
                  error={
                    employeeState.employeeNameStatus === "error" ? true : false
                  }
                  success={
                    employeeState.employeeNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Email <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={employeeState?.email}
                  name="email"
                  placeholder="Enter Email"
                  disabled={formType != "add"}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "email" })
                  }
                  error={employeeState.emailStatus === "error" ? true : false}
                  success={
                    employeeState.emailStatus === "success" ? true : false
                  }
                />
                {employeeState.emailStatus === "error" ? (
                  <FormControl error>
                    <FormHelperText>Invalid Email</FormHelperText>
                  </FormControl>
                ) : null}
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={employeeState?.contactNumber}
                  type="number"
                  name="contactNumber"
                  placeholder="Enter Contact Number"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "contactNumber" })
                  }
                  error={
                    employeeState.contactNumberStatus === "error" ? true : false
                  }
                  success={
                    employeeState.contactNumberStatus === "success"
                      ? true
                      : false
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />

                {employeeState.contactNumberStatus === "error" ? (
                  <FormControl error>
                    <FormHelperText>
                      {/* Contact number must be between 8 and 15 digits long. */}
                      Contact Number should accept only 8 digits.
                    </FormHelperText>
                  </FormControl>
                ) : null}
              </Grid>

              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Role <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="role"
                  value={employeeState?.role}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={roleDataOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.role,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: "role" })}
                  error={employeeState.roleStatus === "error" ? true : false}
                  success={
                    employeeState.roleStatus === "success" ? true : false
                  }
                  isLoading={roleLoading}
                  isClearable
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="department"
                  value={employeeState?.department}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={departmentDataOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.role,
                    };
                  })}
                  onChange={(e, s) =>
                    dispatch({ value: e, name: "department" })
                  }
                  error={
                    employeeState.departmentStatus === "error" ? true : false
                  }
                  success={
                    employeeState.departmentStatus === "success" ? true : false
                  }
                  isLoading={departmentLoading}
                  isClearable
                />
              </Grid>
              {/* <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={employeeState?.department}
                  name="department"
                  placeholder="Enter Department"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "department" })
                  }
                  error={
                    employeeState.departmentStatus === "error" ? true : false
                  }
                  success={
                    employeeState.departmentStatus === "success" ? true : false
                  }
                />
              </Grid> */}
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Image
                  </MaterialTypography>
                </MaterialBox>
                <FullscreenIcon
                  fontSize="small"
                  className="viewIcon"
                  onClick={() => {
                    setDialogOpen(true);
                    // setImageId=(formValue?.profilePicture)
                  }}
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                />
                <ImageSelector
                  onImageSelect={handleImageSelect}
                  imageUrl={formValue?.profilePicture}
                  disabled={inputDisble}
                />
              </Grid>

              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  multiline
                  rows={5}
                  value={employeeState?.address}
                  name="address"
                  placeholder="Enter Address"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "address" })
                  }
                  error={employeeState.addressStatus === "error" ? true : false}
                  success={
                    employeeState.addressStatus === "success" ? true : false
                  }
                />
              </Grid>

              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginTop: "15px",
                }}
                size={{ lg: 4, xs: 5, sm: 3 }}
              >
                <MaterialBox lineHeight={0} display="block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    display="block"
                  >
                    Mobile Access
                  </MaterialTypography>
                  <Switch
                    checked={employeeState?.mobileUse}
                    onChange={(e) =>
                      dispatch({ value: e.target.checked, name: "mobileUse" })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                    disabled={inputDisble}
                  />
                </MaterialBox>
                <MaterialBox lineHeight={0} display="block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    display="block"
                  >
                    Web Access
                  </MaterialTypography>
                  <Switch
                    checked={employeeState?.webUse}
                    onChange={(e) =>
                      dispatch({ value: e.target.checked, name: "webUse" })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                    disabled={inputDisble}
                  />
                </MaterialBox>
                {formType != "add" && (
                  <MaterialBox lineHeight={0} display="block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      display="block"
                    >
                      Active User
                    </MaterialTypography>
                    <Switch
                      checked={employeeState?.isActive}
                      onChange={(e) =>
                        dispatch({ value: e.target.checked, name: "isActive" })
                      }
                      inputProps={{ "aria-label": "controlled" }}
                      disabled={inputDisble}
                    />
                  </MaterialBox>
                )}
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/employee")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={
                  formType == "add" ? handleAddEmployee : handleUpdateEmployee
                }
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default EmployeeForm;
